<template>
  <div class="container">
    <div class="gameDownload">
      <img :src="`${cdnUrl}/tg2.1/3.png`" class="logo" alt="">
      <div>
        <p>太古封魔录2</p>
        <p>百世轮回 千转情缘 唯你不变</p>
      </div>
      <img :src="`${cdnUrl}/tg2.1/4/1.png`" class="btn" alt="" @click="downloadGame()">
    </div>
    <div class="op">
      <!-- <img :src="`${cdnUrl}/tg2/back.png`" alt="" @click="backHome"/> -->
      <div @click="showModal(6)" v-if="userInfo.user_id">切换账号</div>
      <div v-else></div>
      <div class="rf" @click="refresh">
        <span>刷新</span>
        <img :src="`${cdnUrl}/tg2/refresh.png`" alt="" />
      </div>
    </div>
    <!-- top img -->
    <!-- <img class="top-i" :src="`${cdnUrl}/tg2/7/21.jpg`" alt="" /> -->
    <!-- desc -->
    <img class="dc" :src="`${cdnUrl}/tg2.1/3/19.png`" alt="" />
    <p style="margin-top: 10px">新服集结！在活动时间内于新服创角</p>
    <p>可同时参与新服7天/15天冲级活动</p>
    <p class="f-1">赢取<span>1.5w</span>仙玉！更有限定新服称号、至尊坐骑！</p>
    <p class="bind">
      <span v-if="!userInfo.user_id" @click="handleLoginClick">【点击登录】</span>
      <span v-if="!roleInfo.role_id && userInfo.user_id" @click="handleBindClick">{{ userInfo.user_name }}，【绑定角色】</span>
      <span v-else-if="roleInfo.role_id && userInfo.user_id" @click="handleBindClick">区服：{{ roleInfo.server_name }}，角色：{{ roleInfo.role_name }} 【更换绑定】</span>
    </p>
    <div class="tab">
      <!-- 冲级 -->
      <div :class="['tab-i', actType == 1 ? 'active' : '']" alt="">
        <span @click="actType = 1"></span>
        <span @click="actType = 2"></span>
      </div>
      <!-- 活动规则 -->
      <img class="rule" :src="`${cdnUrl}/tg2.1/3/4.png`" alt="" @click="showModal(5)" />
    </div>
    <p class="p-h">点击可切换7天/15天冲级活动</p>
    <ul class="gift-list" v-if="actType == 1">
      <li v-for="(item, index) in gift1" :key="index">
        <img :src="item.img" alt="" />
        <!--可领取· -->
        <button v-if="item.status == 1 || !roleInfo || !roleInfo.role_id" class="r2" @click="giftReceive(item)"></button>
        <!--未满足 -->
        <button v-else-if="item.status == 0 || item.status == 3" class="r1" @click="giftReceive(item)"></button>
        <!-- 已领取 -->
        <button v-else-if="item.status == 2" class="r3" @click="giftReceive(item)"></button>
      </li>
    </ul>
    <ul class="gift-list" v-if="actType == 2">
      <li v-for="(item, index) in gift2" :key="index">
        <img :src="item.img" alt="" />
        <!--可领取· -->
        <button v-if="item.status == 1 || !roleInfo || !roleInfo.role_id" class="r2" @click="giftReceive(item)"></button>
        <!--未满足 -->
        <button v-else-if="item.status == 0 || item.status == 3" class="r1" @click="giftReceive(item)"></button>
        <!-- 已领取 -->
        <button v-else-if="item.status == 2" class="r3" @click="giftReceive(item)"></button>
      </li>
    </ul>
    <div class="btn-g">
      <!-- 我的奖品· -->
      <button @click="showGiftRecord"></button>
      <!-- 返回首页 -->
      <!-- <button @click="backHome"></button> -->
    </div>
    <Modal
      v-show="modalVisible"
      ref="modal"
      :server="serverList"
      @close="modalVisible = false"
      @bind="handleBind"
      @loginSuccess="onLoginSuccess"
      @download="downloadGame(1)"
    ></Modal>
  </div>
</template>
<script>
import { CDN_URL_1 } from "@/config";
import { shaogeActInfo, shaogeActRole, shaogeActRoleReceive, shaogeActRoleRecord, eventTrackExtra } from "@/apis/tg";
import _ from 'lodash';
import Modal from './cjActModal.vue'
import { Toast } from 'vant';

export default {
  data() {
    return {
      cdnUrl: CDN_URL_1,
      userInfo: {},
      actType: 1, // 1. 7天冲级 2. 15天冲级
      modalVisible: false,
      gift1: [
        {
          img: `${CDN_URL_1}/tg2/7/2.png`,
          shaoge_gift_name: "385级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/7.png`,
          shaoge_gift_name: "380级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/8.png`,
          shaoge_gift_name: "新服创角礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/9.png`,
          shaoge_gift_name: "165级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2.1/3/9.png?v=2`,
          shaoge_gift_name: "220级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/11.png`,
          shaoge_gift_name: "260级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/12.png`,
          shaoge_gift_name: "290级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2.1/3/12.png?v=2`,
          shaoge_gift_name: "320级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/14.png`,
          shaoge_gift_name: "345级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/15.png`,
          shaoge_gift_name: "365级7天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/7/16.png`,
          shaoge_gift_name: "375级7天达成礼包",
          status: 0,
        },
      ],
      gift2: [
        {
          img: `${CDN_URL_1}/tg2/15/1.png`,
          shaoge_gift_name: "470级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/15/2.png`,
          shaoge_gift_name: "465级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/15/3.png`,
          shaoge_gift_name: "320级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/15/4.png`,
          shaoge_gift_name: "350级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/15/5.png`,
          shaoge_gift_name: "375级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/15/6.png`,
          shaoge_gift_name: "400级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2.1/1/7.png?v=1`,
          shaoge_gift_name: "425级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2/15/8.png`,
          shaoge_gift_name: "445级15天达成礼包",
          status: 0,
        },
        {
          img: `${CDN_URL_1}/tg2.1/1/9.png?v=1`,
          shaoge_gift_name: "460级15天达成礼包",
          status: 0,
        },
      ],
      serverList: [],
      roleInfo: {}
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    downloadGame(type) {
      location.href = "http://pop.ad.wxbz123.cn/Planlist/ad?id=65b762a5c255067a0c37c892";
      this.buryReport(type ? "SG_DOWNLOAD_REG" : "SG_DOWNLOAD", {});
    },
    getUserInfo() {
      const user = localStorage.getItem("tg_user_info") || "";
      if (user) {
        try {
          this.userInfo = JSON.parse(user);
          this.roleInfo = this.userInfo.role || {};
        } catch (error) {
          this.userInfo = {};
        }
      }
      this.buryReport("SG_OPEN", {});
      // if (
      //   !this.userInfo.user_name ||
      //   !this.userInfo.user_id ||
      //   !this.userInfo.activity_token
      // ) {
      //   this.$router.replace({name: "tglm"});
      //   return;
      // }
      if (this.userInfo.user_name && this.userInfo.user_id && this.userInfo.activity_token) {
        this.getRoleInfo()
      }
      this.getActInfo();
    },
    onLoginSuccess(user) {
      this.userInfo = user;
      this.getUserInfo();
      this.buryReport("SG_AUTHORIZE", {
        user_name: this.userInfo.user_name
      })
      // this.handleBindClick();
      this.showModal(2)
      this.roleInfo = {};
      this.userInfo.role = {}
    },
    handleLoginClick() {
      this.showModal(6)
    },
    handleBindClick() {
      this.showModal(3);
      this.buryReport("OFFICIAL_SG_BIND", {
        user_name: this.userInfo.user_name,
        user_id: this.userInfo.user_id,
        server_id: this.roleInfo.server_id,
        server_name: this.roleInfo.server_name,
        role_id: this.roleInfo.role_id,
        role_name: this.roleInfo.role_name
      })
    },
    async getActInfo(bindList) {
      let list = [];
      if (!bindList) {
        const r = await shaogeActInfo({
          user_id: this.userInfo.user_id || '',
          activity_token: this.userInfo.activity_token || '',
          activity_id: 3,
        });
        list = r.content.activity_gift_list;
      } else {
        list = bindList;
      }
      const gift1 = this.gift1.map(item => {
        const giftItem = list.find(listItem => listItem.shaoge_gift_name === item.shaoge_gift_name);
        return {
          ...item,
          id: giftItem.shaoge_gift_id,
          status: giftItem.status,
        }
      })
      this.gift1 = _.cloneDeep(gift1);
      const gift2 = this.gift2.map(item => {
        const giftItem = list.find(listItem => listItem.shaoge_gift_name === item.shaoge_gift_name);
        return {
          ...item,
          id: giftItem.shaoge_gift_id,
          status: giftItem.status,
        }
      })
      this.gift2 = _.cloneDeep(gift2);
    },
    // 获取角色信息
    async getRoleInfo() {
      const r = await shaogeActRole({
        user_id: this.userInfo.user_id,
        activity_token: this.userInfo.activity_token,
        activity_id: 3,
      })
      let serverList = [];
      r.content.role_list.map(role => {
        const res = serverList.findIndex(item => item.id === role.server_id);
        if (res === -1) {
          serverList.push({
            id: role.server_id,
            text: role.server_name,
            role: [
              {
                id: role.role_id,
                text: role.role_name
              }
            ]
          })
        } else {
          serverList[res].role.push({
            id: role.role_id,
            text: role.role_name
          })
        }
      })
      this.serverList = serverList;
    },
    refresh() {
      location.reload()
    },
    showModal(step) {
      this.modalVisible = true;
      this.$refs.modal.setStep(step);
      this.$refs.modal.userInfo = this.userInfo;
    },
    // 处理绑定成功
    handleBind(res) {
      Toast('绑定成功')
      this.userInfo.role = res.user_role;
      this.roleInfo = res.user_role;
      localStorage.setItem('tg_user_info', JSON.stringify(this.userInfo));
      this.getActInfo();
      this.modalVisible = false;
    },
    // 礼包领取
    async giftReceive(item) {
      try {
        let text = '领取';
        if (item.status == 0) {
          text = '未满足';
        } else if (item.status == 2) {
          text = '已领取'
        }
        this.buryReport("OFFICIAL_SG_LV_RECEIVE", {
          user_name: this.userInfo.user_name,
          user_id: this.userInfo.user_id,
          server_id: this.roleInfo.server_id,
          server_name: this.roleInfo.server_name,
          role_id: this.roleInfo.role_id,
          role_name: this.roleInfo.role_name,
          gift_name: item.shaoge_gift_name,
          button: text
        }) 
      } catch (error) {
        console.log(error)
      }
      if (!this.roleInfo.role_id && !this.userInfo.user_id) {
        this.showModal(6)
        return;
      }
      if (!this.roleInfo.role_id && this.userInfo.user_id) {
        this.showModal(3);
        return;
      }
      
      if (item.status == 0) {
        Toast('未满足领取条件');
        return;
      }
      if (item.status == 2) {
        Toast('您已领取过啦');
        return;
      }

      if (item.status == 3) {
        Toast('活动已结束');
        return;
      }
      
      await shaogeActRoleReceive({
        user_id: this.userInfo.user_id,
        server_id: this.roleInfo.server_id,
        role_id: this.roleInfo.role_id,
        activity_token: this.userInfo.activity_token,
        shaoge_gift_id: item.id,
        activity_id: 3,
      })
      this.showModal(1);
      this.getActInfo();
    },
    backHome() {
      this.$router.replace({name: "tglm"});
    },
    isWeiXin() {
      const ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    isAndroid() {
      let u = navigator.userAgent;
      return u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
    },
    // 展示奖品列表
    async showGiftRecord() {
      this.buryReport("OFFICIAL_SG_RECORD", {
        user_name: this.userInfo.user_name,
        user_id: this.userInfo.user_id,
        server_id: this.roleInfo.server_id,
        server_name: this.roleInfo.server_name,
        role_id: this.roleInfo.role_id,
        role_name: this.roleInfo.role_name,
      }) 

      if (!this.roleInfo.role_id && !this.userInfo.user_id) {
        this.showModal(6)
        return;
      }
      if (!this.roleInfo.role_id && this.userInfo.user_id) {
        this.showModal(3);
        return;
      }

      const r = await shaogeActRoleRecord({
        user_id: this.userInfo.user_id,
        activity_token: this.userInfo.activity_token,
        activity_id: 3,
      });
      this.$refs.modal.giftList = r.content.record_list;
      this.showModal(4);
    },
    buryReport(type, extra_data) {
      var getBrowser = function() {
        var UserAgent = navigator.userAgent.toLowerCase();
        var browserInfo = {};
        var browserArray = {
          IE: window.ActiveXObject || "ActiveXObject" in window,
          // IE
          Chrome:
            UserAgent.indexOf("chrome") > -1 &&
            UserAgent.indexOf("safari") > -1,
          // Chrome浏览器
          Firefox: UserAgent.indexOf("firefox") > -1,
          // 火狐浏览器
          Opera: UserAgent.indexOf("opera") > -1,
          // Opera浏览器
          Safari:
            UserAgent.indexOf("safari") > -1 &&
            UserAgent.indexOf("chrome") == -1,
          // safari浏览器
          Edge: UserAgent.indexOf("edge") > -1,
          // Edge浏览器
          QQBrowser: /qqbrowser/.test(UserAgent),
          // qq浏览器
          WeixinBrowser: /MicroMessenger/i.test(UserAgent),
          // 微信浏览器
        };
        // console.log(browserArray)
        for (var i in browserArray) {
          if (browserArray[i]) {
            var versions = "";
            if (i == "IE") {
              versions = UserAgent.match(/(msie\s|trident.*rv:)([\w.]+)/)[2];
            } else if (i == "Chrome") {
              for (var mt in navigator.mimeTypes) {
                //检测是否是360浏览器(测试只有pc端的360才起作用)
                if (
                  navigator.mimeTypes[mt]["type"] ==
                  "application/360softmgrplugin"
                ) {
                  i = "360";
                }
              }
              versions = UserAgent.match(/chrome\/([\d.]+)/)[1];
            } else if (i == "Firefox") {
              versions = UserAgent.match(/firefox\/([\d.]+)/)[1];
            } else if (i == "Opera") {
              versions = UserAgent.match(/opera\/([\d.]+)/)[1];
            } else if (i == "Safari") {
              versions = UserAgent.match(/version\/([\d.]+)/)[1];
            } else if (i == "Edge") {
              versions = UserAgent.match(/edge\/([\d.]+)/)[1];
            } else if (i == "QQBrowser") {
              versions = UserAgent.match(/qqbrowser\/([\d.]+)/)[1];
            }
            browserInfo.type = i;
            browserInfo.versions = parseInt(versions);
          }
        }
        return browserInfo;
      };

      eventTrackExtra({
        appkey: "0",
        event: type,
        device_id: "null",
        device_name: "null",
        system_version: "null",
        extra_data: JSON.stringify({
          ...extra_data,
          browser: getBrowser().type,
          browser_version: getBrowser().versions,
        }),
        os: this.isAndroid() ? "android" : "ios",
        user_id: this.userInfo.user_id || "null",
        client_extra_data: JSON.stringify({
          os: this.isAndroid() ? "android" : "ios",
          jh_channel: "null",
        }),
      });
    },
  },
  components: {
    Modal
  },
};
</script>
<style scoped lang="scss">
.container {
  background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/1.jpg?v=1")
    no-repeat;
  background-size: 100% 100%;
  width: 375px;
  overflow: hidden;
  height: 1600px;
  margin: auto;
  position: relative;
  color: #3e3e3e;
  padding-bottom: 100px;
  margin-top: 59px;
  .gameDownload {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    height: 60px;
    background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/4/2.png?v=1")
    no-repeat;
    background-size: 100% 100%;
    align-items: center;
    padding-left: 22px;
    z-index: 1;
    .logo {
      width: 50px;
      height: 50px;
      margin-right: 19px;
      border-radius: 8px;
    }
    > div {
      color: #FFFFFF;
      font-size: 12px;
      > p:nth-child(2) {
        margin-top: 10px;
        color: #FFEE9D;
        font-size: 8px;
      }
    }
    .btn {
      width: 102px;
      height: 30px;
      position: absolute;
      right: 18px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .op {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #FFFFFF;
    font-size: 14px;
    padding-left: 10px;
    img {
      height: 14px;
      box-sizing: content-box;
      padding: 10px;
    }
    .rf {
      display: flex;
      align-items: center;
    }
  }
  .dc {
    width: 90%;
    margin-left: 40px;
    margin-top: 340px;
  }
  > p {
    font-size: 11px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 2px;
  }
  .f-1 {
    color: #3e3e3e;
    font-size: 14px;
    > span {
      color: #9f2b21;
    }
  }
  .bind {
    color: #4660c5;
    margin: {
      top: 15px;
      bottom: 5px;
    }
  }
  .tab {
    width: 100%;
    position: relative;
    .tab-i {
      width: 260px;
      height: 36px;
      background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/1/10.png")
        no-repeat;
      background-size: 100% 100%;
      display: block;
      margin: auto;
      display: flex;
      &.active {
        background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/3/2.png")
          no-repeat;
        background-size: 100% 100%;
      }
      > span {
        width: 50%;
      }
    }
    .rule {
      position: absolute;
      top: 5px;
      right: 0px;
      width: 45px;
    }
  }
  .p-h {
    color: #DB242E;
    font-size: 9px;
  }
  .gift-list {
    background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2/7/3.png?v=1")
      no-repeat;
    background-size: 100% 100%;
    padding: 20px 0px;
    width: 360px;
    margin: auto;
    > li {
      display: block;
      margin: auto;
      width: 320px;
      height: 63px;
      position: relative;
      margin-bottom: 5px;
      > img {
        width: 320px;
        height: 63px;
      }
      > button {
        position: absolute;
        right: 12px;
        top: 20px;
        width: 48px;
        height: 17px;
        border: none;
        outline: none;
        &:active {
          opacity: 0.8;
        }
      }
      .r1 {
        background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2/7/17.png?v=1")
          no-repeat;
        background-size: 100% 100%;
      }
      .r2 {
        background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2/7/6.png?v=1")
          no-repeat;
        background-size: 100% 100%;
      }
      .r3 {
        background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2/7/20.png?v=1")
          no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .btn-g {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    > button {
      background: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/tg2.1/3/18.png?v=1")
        no-repeat;
      background-size: 100% 100%;
      width: 140px;
      height: 54px;
      border: none;
      outline: none;
      margin: 0 10px;
      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>
